import http from '@/utils/http' //引入axios
export const getpercentage = data => http.post('/kg-analysis/api/transaction/percentage', data) //查找
export const getplatform = data => http.get('/kg-payment/api/platform/findById', {
    params: data
}) //查找
export const getrecycleTypeNum = data => http.post('/kg-analysis/api/transaction/recycleTypeNum', data) //查找
export const getrecycleNum = data => http.post('/kg-analysis/api/transaction/recycleNum', data) //查找
export const getrecycleHour = data => http.post('/kg-analysis/api/transaction/recycleHour', data) //查找
export const getbrand = data => http.get('/kg-analysis/api/bottle/brand', {
    params: data
}) //查找
export const getcapacity = data => http.get('/kg-analysis/api/bottle/capacity', {
    params: data
}) //查找
// 拒收瓶子数据
export const getdayReject = data => http.post('/kg-analysis/api/reject/dayReject', data) //查找
export const getmachineReject = data => http.post('/kg-analysis/api/reject/machineReject', data) //查找
export const getmachineDayReject = data => http.post('/kg-analysis/api/reject/machineDayReject', data) //查找
export const getmachineDaysReject = data => http.post('/kg-analysis/api/reject/machineDaysReject', data) //查找
export const getrejectReason = data => http.post('/kg-analysis/api/reject/rejectReason', data) //查找
export const getMnewAddData = data => http.post('/kg-analysis/api/payment/machineuser', data)
export const getMounthuser = data => http.post('/kg-analysis/api/payment/mounthuser', data)
export const getTotalRecycle = data => http.post('/kg-analysis/api/transaction/totalRecycle', data)
// 指定时间范围内总数
export const recycleTypeNumTotal = data => http.post('/kg-analysis/api/transaction/recycleTypeNumTotal', data)
export default {
    getpercentage,
    getplatform,
    getrecycleTypeNum,
    getrecycleNum,
    getrecycleHour,
    getbrand,
    getcapacity,
    getdayReject,
    getmachineReject,
    getmachineDayReject,
    getmachineDaysReject,
    getrejectReason,
    getMnewAddData,
    getMounthuser,
    getTotalRecycle,
    recycleTypeNumTotal


}